module.exports = __webpack_public_path__ + "static/fanny-coron-72476dc72737703ed3dd48b83d53b442.png";